// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"SearchInputWrapper__searchBoxContainer___OtpOM","searchBoxContainerProject":"SearchInputWrapper__searchBoxContainerProject___cJaJy"};